<template>
  <li class="app-product-information-item-versions">
    <div class="header-box" v-b-toggle="`collapse-${_uid}`">
      {{productInformation.productName}}
    </div>
    <b-collapse class="content-box" :id="`collapse-${_uid}`">
      <div class="app-product-information-product">
        <ul>
          <ProductInformationSheet :product-information="productInformation" :sheet="productInformation.recentVersion" :show-version="true">
            <template v-for="slot in possibleChildSlotsFor('Recent')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </ProductInformationSheet>
        </ul>
        <div class="historic" v-if="hasHistory">
          <slot name="txtVersionSeparator">Vorherige Versionen:</slot>
          <ul>
              <ProductInformationSheet
                v-for="sheet in historicVersionsList"
                :key="sheet.version"
                :product-information="productInformation"
                :sheet="sheet"
                :show-version="true">
                <template v-for="slot in possibleChildSlotsFor('Historic', sheet.version)" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
              </ProductInformationSheet>
          </ul>
        </div>
      </div>
    </b-collapse>
  </li>
</template>

<script>

import ProductInformationSheet from './Sheet.vue'
import slotProxy from '../../../../mixins/slotProxy'
/**
 * Diese Komponente stellt eine ProductInformation als Liste aller Versionen dar dar.
 */
export default {
  components: { ProductInformationSheet },
  mixins: [
    slotProxy()
  ],
  props: {
    productInformation: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    hasHistory: function () {
      return this.productInformation?.historicVersions?.length > 0
    },
    historicVersionsList: function () {
      const [, ...olderVersions] = this.productInformation.historicVersions
      return olderVersions
    }
  },
  name: 'ProductInformationItemVersions'
}
</script>
